{
  "familyId": "TOPO-EU-KLIMAAT",
  "questions": [
    {
      "id": "TOPO-EU-KLIMAAT-001",
      "familyId": "TOPO-EU-KLIMAAT",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "europa",
      "subSkill": "topo_klimaat_eu",
      "questionType": "multiple_choice",
      "question": "Welk klimaat heeft Nederland?",
      "options": [
        "Gematigd zeeklimaat",
        "Mediterraan klimaat",
        "Continentaal klimaat",
        "Poolklimaat"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Klimaatzones Europa",
            "content": "Nederland ligt aan de Noordzee en heeft een gematigd zeeklimaat: milde winters, koele zomers, veel regen. De zee houdt de temperatuur gematigd.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "klimaat_nederland",
      "variantIndex": 1,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Nederland heeft een gematigd zeeklimaat. De Noordzee zorgt voor milde winters en koele zomers. Het regent regelmatig.",
        "solutionSteps": [
          "Nederland ligt aan zee",
          "Zee = gematigd klimaat",
          "Milde winters, koele zomers, veel regen"
        ],
        "distractorExplanations": {
          "0": "Goed! Nederland heeft een gematigd zeeklimaat.",
          "1": "Mediterraan klimaat heeft hete, droge zomers en milde winters. Dat past bij Zuid-Europa (Spanje, Italië). Onthoud: Nederland is te koel en te nat voor mediterraan.",
          "2": "Continentaal klimaat heeft koude winters en warme zomers. Dat past bij Oost-Europa (Rusland, Polen). Nederland ligt aan zee, niet in het binnenland.",
          "3": "Poolklimaat is extreem koud. Dat past bij Noord-Scandinavië. Nederland is veel te warm voor poolklimaat."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-KLIMAAT-001-OPT1",
            "optionIndex": 1,
            "label": "Dat past bij Zuid-Europa (Spanje, Italië)"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-KLIMAAT-001-OPT2",
            "optionIndex": 2,
            "label": "Dat past bij Oost-Europa (Rusland, Polen)"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-KLIMAAT-001-OPT3",
            "optionIndex": 3,
            "label": "Poolklimaat is extreem koud"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_klimaat_eu"
          }
        }
      ]
    },
    {
      "id": "TOPO-EU-KLIMAAT-002",
      "familyId": "TOPO-EU-KLIMAAT",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "europa",
      "subSkill": "topo_klimaat_eu",
      "questionType": "multiple_choice",
      "question": "Welk land heeft een mediterraan klimaat?",
      "options": [
        "Griekenland",
        "Noorwegen",
        "Polen",
        "Ierland"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Mediterraan klimaat",
            "content": "Mediterraan = rond de Middellandse Zee. Hete, droge zomers en milde, natte winters. Landen: Spanje, Italië, Griekenland, Zuid-Frankrijk.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "klimaat_mediterraan",
      "variantIndex": 2,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Griekenland ligt aan de Middellandse Zee en heeft een mediterraan klimaat: hete, droge zomers en milde winters.",
        "solutionSteps": [
          "Mediterraan = rond de Middellandse Zee",
          "Griekenland ligt aan de Middellandse Zee"
        ],
        "distractorExplanations": {
          "0": "Goed! Griekenland heeft een mediterraan klimaat.",
          "1": "Noorwegen heeft een koud klimaat (subarctisch/zeeklimaat). Het ligt te ver naar het noorden voor mediterraan.",
          "2": "Polen heeft een continentaal klimaat: koude winters, warme zomers. Het ligt niet aan de Middellandse Zee.",
          "3": "Ierland heeft een gematigd zeeklimaat, net als Nederland. Het ligt aan de Atlantische Oceaan, niet de Middellandse Zee."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-KLIMAAT-002-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Noorwegen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-KLIMAAT-002-OPT2",
            "optionIndex": 2,
            "label": "Het ligt niet aan de Middellandse Zee"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-KLIMAAT-002-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Ierland"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_klimaat_eu"
          }
        }
      ]
    },
    {
      "id": "TOPO-EU-KLIMAAT-003",
      "familyId": "TOPO-EU-KLIMAAT",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "europa",
      "subSkill": "topo_klimaat_eu",
      "questionType": "multiple_choice",
      "question": "Waarom heeft Moskou koudere winters dan Londen, terwijl ze op dezelfde breedtegraad liggen?",
      "options": [
        "Moskou ligt ver van de zee",
        "Moskou ligt hoger",
        "Londen heeft meer fabrieken",
        "Moskou ligt dichter bij de Noordpool"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zeeklimaat vs continentaal",
            "content": "De zee houdt de temperatuur gematigd. Steden ver van de zee (zoals Moskou) hebben extremere temperaturen: koudere winters, warmere zomers.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "klimaat_continentaal",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Moskou ligt ver van de oceaan (continentaal klimaat). De zee matigt de temperatuur. Zonder zee-invloed worden winters kouder en zomers warmer.",
        "solutionSteps": [
          "Londen: dicht bij zee → gematigd",
          "Moskou: ver van zee → extremer",
          "Continentaal = koudere winters, warmere zomers"
        ],
        "distractorExplanations": {
          "0": "Goed! Afstand tot de zee bepaalt het verschil.",
          "1": "Moskou ligt niet significant hoger dan Londen. De hoogte is niet de reden. Onthoud: afstand tot de zee is de sleutel.",
          "2": "Fabrieken hebben geen groot effect op het klimaat van een hele stad. Onthoud: klimaat wordt bepaald door ligging, niet industrie.",
          "3": "Moskou en Londen liggen op dezelfde breedtegraad — ze zijn even ver van de Noordpool. Onthoud: breedtegraad is gelijk."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-KLIMAAT-003-OPT1",
            "optionIndex": 1,
            "label": "De hoogte is niet de reden"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-KLIMAAT-003-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Londen heeft meer fabrieken"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-KLIMAAT-003-OPT3",
            "optionIndex": 3,
            "label": "Onthoud: breedtegraad is gelijk"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_klimaat_eu"
          }
        }
      ]
    },
    {
      "id": "TOPO-EU-KLIMAAT-004",
      "familyId": "TOPO-EU-KLIMAAT",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "europa",
      "subSkill": "topo_klimaat_eu",
      "questionType": "multiple_choice",
      "question": "Welke klimaatzone vind je in Noord-Scandinavië (boven de poolcirkel)?",
      "options": [
        "Subarctisch/poolklimaat",
        "Gematigd zeeklimaat",
        "Mediterraan klimaat",
        "Steppeklimaat"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Poolcirkel",
            "content": "Boven de poolcirkel is het subarctisch of poolklimaat: zeer koude winters, korte zomers. In de winter is het wekenlang donker.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "klimaat_pool",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Noord-Scandinavië (boven de poolcirkel) heeft een subarctisch/poolklimaat: extreem koude winters, korte zomers, weinig neerslag.",
        "solutionSteps": [
          "Boven de poolcirkel = subarctisch",
          "Zeer koud, korte zomers"
        ],
        "distractorExplanations": {
          "0": "Goed! Boven de poolcirkel = subarctisch/poolklimaat.",
          "1": "Gematigd zeeklimaat past bij West-Europa (Nederland, Engeland). Noord-Scandinavië is veel kouder.",
          "2": "Mediterraan klimaat past bij Zuid-Europa. Noord-Scandinavië is het tegenovergestelde.",
          "3": "Steppeklimaat is droog en warm. Dat past bij Centraal-Azië, niet Noord-Scandinavië."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-KLIMAAT-004-OPT1",
            "optionIndex": 1,
            "label": "Noord-Scandinavië is veel kouder"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-KLIMAAT-004-OPT2",
            "optionIndex": 2,
            "label": "Mediterraan klimaat past bij Zuid-Europa"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-KLIMAAT-004-OPT3",
            "optionIndex": 3,
            "label": "Steppeklimaat is droog en warm"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_klimaat_eu"
          }
        }
      ]
    },
    {
      "id": "TOPO-EU-KLIMAAT-005",
      "familyId": "TOPO-EU-KLIMAAT",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "europa",
      "subSkill": "topo_klimaat_eu",
      "questionType": "matching",
      "question": "Koppel elk land aan de juiste klimaatzone.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": [
          "Spanje",
          "Nederland",
          "Finland",
          "Rusland (Moskou)"
        ],
        "rightItems": [
          "gematigd zeeklimaat",
          "continentaal klimaat",
          "mediterraan klimaat",
          "subarctisch klimaat"
        ],
        "correctMatches": {
          "0": 2,
          "1": 0,
          "2": 3,
          "3": 1
        }
      },
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Klimaatzones",
            "content": "Spanje = mediterraan (warm, droog). Nederland = gematigd zee (mild, nat). Finland = subarctisch (koud). Rusland = continentaal (extremen).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "klimaat_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Spanje = mediterraan, Nederland = gematigd zeeklimaat, Finland = subarctisch, Rusland (Moskou) = continentaal.",
        "solutionSteps": [
          "Spanje → mediterraan (Middellandse Zee)",
          "Nederland → gematigd zee (Noordzee)",
          "Finland → subarctisch (poolcirkel)",
          "Rusland → continentaal (ver van zee)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_klimaat_eu"
          }
        }
      ]
    }
  ]
}